import type { BoggleGameModeId } from '~/boggle/gameModes'
import type { BoggleChallengeConfigurationDefinition } from './types'
import { basic } from './definitions/basic'
import { contagion } from './definitions/contagion'

export const BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS = [basic, contagion] as const

export function isBoggleChallengeConfigurationEnabled(
  configuration: BoggleChallengeConfigurationDefinition,
): boolean {
  return configuration.enabled !== false
}

export type BoggleChallengeConfigurationId =
  (typeof BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS)[number]['id']

export const BOGGLE_CHALLENGE_CONFIGURATION_REGISTRY = Object.fromEntries(
  BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS.map(configuration => [
    configuration.id,
    configuration,
  ]),
) as Record<
  BoggleChallengeConfigurationId,
  (typeof BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS)[number]
>

export function getBoggleChallengeConfigurationDefinition(
  configurationId: BoggleChallengeConfigurationId,
) {
  return BOGGLE_CHALLENGE_CONFIGURATION_REGISTRY[configurationId]
}

export function isBoggleChallengeConfigurationId(
  value: string,
): value is BoggleChallengeConfigurationId {
  return value in BOGGLE_CHALLENGE_CONFIGURATION_REGISTRY
}

export function getBoggleChallengeConfigurationDefinitionsForMode(
  gameModeId: BoggleGameModeId,
) {
  return BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS.filter(
    configuration =>
      configuration.gameModeIds.some(current => current === gameModeId) &&
      isBoggleChallengeConfigurationEnabled(configuration),
  )
}
